"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Verify2FACodeResponse = exports.Verify2FACodeRequest = exports.Send2FACodeResponse = exports.Resend2FASignInRequest = exports.Verify2FASignInResponse = exports.Verify2FASignInRequest = exports.SignInResponse = exports.SignInRequest = void 0;
const zod_1 = require("zod");
exports.SignInRequest = zod_1.z.object({
    email: zod_1.z.string().email(),
    password: zod_1.z.string().min(1),
});
exports.SignInResponse = zod_1.z.union([
    zod_1.z.object({
        twoFactorRequired: zod_1.z.literal(true),
        sessionToken: zod_1.z.string(),
    }),
    zod_1.z.object({
        twoFactorRequired: zod_1.z.literal(false),
        tokens: zod_1.z.object({
            idToken: zod_1.z.string(),
            accessToken: zod_1.z.string(),
            refreshToken: zod_1.z.string(),
        }),
    }),
]);
exports.Verify2FASignInRequest = zod_1.z.object({
    sessionToken: zod_1.z.string(),
    code: zod_1.z.string().length(6),
});
exports.Verify2FASignInResponse = zod_1.z.object({
    tokens: zod_1.z.object({
        idToken: zod_1.z.string(),
        accessToken: zod_1.z.string(),
        refreshToken: zod_1.z.string(),
    }),
});
exports.Resend2FASignInRequest = zod_1.z.object({
    sessionToken: zod_1.z.string(),
});
exports.Send2FACodeResponse = zod_1.z.object({
    sent: zod_1.z.boolean(),
});
exports.Verify2FACodeRequest = zod_1.z.object({
    code: zod_1.z.string().length(6),
});
exports.Verify2FACodeResponse = zod_1.z.object({
    verified: zod_1.z.boolean(),
});
